import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import VerbRoute from './VerbRoute';
import BasicErrorBoundary from './errorBoundaries/BasicErrorBoundary';
// import { Redirect } from 'react-router-dom';
// import queryString from 'query-string';
// import { getLocalStorage } from '../actions/LocalStorage';

class AuthenticatedRoute extends PureComponent {
    static propTypes = {
        isAuthenticated: PropTypes.bool,
        customProps: PropTypes.object,
        component: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
    };

    render() {
        const { isAuthenticated, component, customProps = {}, loggedInUserId = '', idToken = '', ...rest } = this.props;
        return (
            <VerbRoute
                {...rest}
                render={(routeProps) => {
                    const propsToPass = {
                        ...customProps,
                        ...routeProps
                    };

                    // const queryParams = queryString.parse(routeProps.location.search);

                    // const userId = getLocalStorage({ key: 'userId', dispatchDisabled: true });
                    // if (queryParams.editProfile && userId) {
                    //     const toParam = `profile/${userId}/edit`;
                    //     return <Redirect to={toParam} />;
                    // }

                    // if (routeProps.match?.path === '/pathway/:id' && routeProps.match?.params?.id) {
                    //     return (
                    //         <Redirect
                    //             to={{
                    //                 pathname: '/home',
                    //                 search: `pathwayPermalink=${routeProps.match.params.id}&forceOpenPanel=true`
                    //             }}
                    //         />
                    //     );
                    // }
                    return <BasicErrorBoundary>{React.createElement(component, propsToPass)}</BasicErrorBoundary>;
                }}
            />
        );
    }
}

const mapStateToProps = (state) => {
    const {
        auth: { isAuthenticated, loggedInUserId, idToken }
    } = state;

    return {
        isAuthenticated,
        loggedInUserId,
        idToken,
    };
};

export const AuthenticatedRouteComponent = AuthenticatedRoute;
export default connect(mapStateToProps)(AuthenticatedRoute);
